import { render, staticRenderFns } from "./mlr.vue?vue&type=template&id=701a0607"
import script from "./mlr.vue?vue&type=script&lang=js"
export * from "./mlr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports